/**
 * Authentication Feature Constants
 */

export const AUTH_ENDPOINTS = {
  LOGIN: '/api/login',
  LOGOUT: '/api/logout',
  TOKEN: '/api/auth/token',
} as const;

export const AUTH_STORAGE_KEYS = {
  ACCESS_TOKEN: 'ping_access_token',
  EXPIRES_AT: 'ping_expires_at',
  USER_INFO: 'ping_user_info',
  EMAIL: 'ping_email',
  GIVEN_NAME: 'ping_given_name',
  FAMILY_NAME: 'ping_family_name',
  CODE_VERIFIER: 'ping_code_verifier',
  TOKEN_TYPE: 'ping_token_type',
  SCOPE: 'ping_scope',
  EXPIRES_IN: 'ping_expires_in',
  CART_ID: 'cartId',
  CART_ID_PREFIX: 'cartId_',
  CART_RESOLVED: 'cartResolved',
  POST_LOGIN_REDIRECT: 'postLoginRedirect',
  JUST_LOGGED_IN: 'justLoggedIn',
} as const;

export const AUTH_ERROR_CODES = {
  URL_GENERATION_FAILED: 'AUTH_URL_GENERATION_FAILED',
  OAUTH_CALLBACK_ERROR: 'OAUTH_CALLBACK_ERROR',
  MISSING_AUTH_CODE: 'MISSING_AUTH_CODE',
  CALLBACK_FAILED: 'CALLBACK_FAILED',
  TOKEN_EXCHANGE_NETWORK_ERROR: 'TOKEN_EXCHANGE_NETWORK_ERROR',
  TOKEN_EXCHANGE_FAILED: 'TOKEN_EXCHANGE_FAILED',
  TOKEN_RESPONSE_PARSE_ERROR: 'TOKEN_RESPONSE_PARSE_ERROR',
} as const;

export const AUTH_MESSAGES = {
  // Error Messages
  BACKEND_LOGIN_INIT_FAILED: 'Backend login-initiation failed',
  NO_AUTH_CODE_RECEIVED: 'No authorization code received',
  UNABLE_TO_READ_ERROR: 'Unable to read error response',
  INVALID_TOKEN_JSON: 'Invalid JSON in token response',
  AUTH_FAILED: 'Authentication failed',
  CALLBACK_HANDLING_FAILED: 'Callback handling failed',
  NETWORK_ERROR_TOKEN_EXCHANGE: 'Network error during token exchange',

  // Status Messages
  PROCESSING_AUTH: 'Processing authentication...',
  AUTH_SUCCESS_REDIRECTING: 'Authentication successful! Redirecting...',
  PLEASE_WAIT: 'Please wait...',

  // UI Labels - Logout PopUp
  LOGOUT_POPUP_TITLE: "Your booking isn't complete.",
  LOGOUT_POPUP_BODY: "If you leave now, your basket will be saved. Click cancel to finish checkout.",
  LOGOUT_POPUP_CANCEL: 'Cancel',
  LOGOUT_POPUP_CONFIRM: 'Leave',
  LOGOUT_POPUP_CLOSE_ARIA: 'Close',
} as const;

export const AUTH_CONFIG = {
  PROVIDER_PING: 'ping',
} as const;
